import { useState } from "react";
import axios from "axios";
import { useParams, useSearchParams } from "react-router-dom";
import Loader from "../components/loader";
import "./RecoverPassword.css";

const SUCCESS_MESSAGE =
  "Password reset successful! You can now close this window and log in to Marsmate AI.";

export default function RecoverPassword() {
  const { token } = useParams();
  const [search] = useSearchParams();
  const email = search.get("email") || "";
  const requestedUserType =
    (search.get("userType") || search.get("type") || "").toLowerCase();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const submitReset = (endpoint, payload) =>
    axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/${endpoint}`,
      payload,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  const handleSubmit = async (event) => {
    event.preventDefault();

    const backendBase = process.env.REACT_APP_BACKEND_URL;

    if (!token || !email) {
      setMsg("Reset link is invalid or incomplete");
      return;
    }

    if (!backendBase) {
      setMsg("Backend URL is not configured");
      return;
    }

    if (!password || !confirm) {
      setMsg("All fields are required");
      return;
    }

    if (password !== confirm) {
      setMsg("Passwords do not match");
      return;
    }

    setLoading(true);
    setMsg("");

    const payload = {
      token,
      email,
      newPassword: password,
      confirmPassword: confirm,
    };

    const primaryEndpoint =
      requestedUserType === "student"
        ? "student/password"
        : "auth/password";

    try {
      await submitReset(primaryEndpoint, payload);
      setIsSuccess(true);
      setPassword("");
      setConfirm("");
      setMsg(SUCCESS_MESSAGE);
    } catch (error) {
      const shouldTryStudentFallback =
        requestedUserType !== "student" &&
        error?.response?.status === 404 &&
        error?.response?.data?.message ===
          "User with this email does not exist";

      if (shouldTryStudentFallback) {
        try {
          await submitReset("student/password", payload);
          setIsSuccess(true);
          setPassword("");
          setConfirm("");
          setMsg(SUCCESS_MESSAGE);
        } catch (fallbackError) {
          setMsg(
            fallbackError?.response?.data?.message ||
              fallbackError?.message ||
              "Something went wrong"
          );
        }
      } else {
        setMsg(
          error?.response?.data?.message ||
            error?.message ||
            "Something went wrong"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="recover-container-main">
      <div className="recover-box-main">
        <h2>Set New Password</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading || isSuccess}
          />

          <input
            type="password"
            placeholder="Confirm Password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            disabled={loading || isSuccess}
          />

          <button type="submit" disabled={loading || isSuccess}>
            {loading
              ? "Updating..."
              : isSuccess
              ? "Password Updated"
              : "Update Password"}
          </button>
        </form>

        {loading && <Loader />}
        <p>{msg}</p>
      </div>
    </div>
  );
}
